/*
 * @Author: 123 1578458020@qq.com
 * @Date: 2023-03-09 15:00:13
 * @LastEditors: 123 1578458020@qq.com
 * @LastEditTime: 2023-03-09 17:22:07
 * @FilePath: \bluesky\bsr-pc\src\routes\find\FLogin.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import { Form, Icon, Input, Button } from 'antd';
import { app } from "../../app"
import "./flogin.css";
// import config from "../../config"
// import api from "../../api"

class FLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                // console.log('Received values of form: ', values);
                let data = {
                    mobile: values.phone,
                    pwd: values.password,
                }
                console.log(data);
                let flag = await this.props.success(data)
                if (flag) {
                    await this.setData({ submit_loading: false, searchplayerList: [], selPpeList: [], head_img: null })
                    this.props.form.resetFields()
                }
            }
        });
    };

    fastRge = () => {
        this.props.reg();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit} className="login-form">
                <Form.Item
                    label='手机号码'
                    style={{ marginBottom: 0 }}
                >
                    {getFieldDecorator('phone', {
                        rules: [
                            { required: true, message: '请输入手机号码!' },
                            {
                                required: true,
                                validator: (rule, value) => {
                                    // let reg = new RegExp(/^1[3456789]\d{9}$/);
                                    // console.log(reg.test(value));
                                    if (value.length != 11) {
                                        return Promise.reject('请输入正确的手机号码');
                                    } else {
                                        return Promise.resolve();
                                    }
                                }
                            },
                        ],
                    })(
                        <Input
                            prefix={<Icon type="phone" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="手机号码"
                        />,
                    )}
                </Form.Item>
                <Form.Item
                    label='查询密码'
                    style={{ marginBottom: 0 }}
                >
                    {getFieldDecorator('password', {
                        rules: [
                            { required: true, message: '请输入查询密码!' },
                            {
                                required: true,
                                validator: (rule, value) => {
                                    let reg = new RegExp(/[\u4E00-\u9FA5]/);
                                    if (reg.test(value)) {
                                        return Promise.reject('查询密码不能为汉字');
                                    } else {
                                        return Promise.resolve();
                                    }
                                }
                            },
                        ],
                    })(
                        <Input
                            prefix={<Icon type="lock" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            type="password"
                            placeholder="查询密码"
                        />,
                    )}
                </Form.Item>
                <div className="box">
                    <p className="animate">
                        查询密码用于登录寻人大厅，查询/修改已布的寻人启事
                    </p>
                </div>

                <Form.Item style={{ margin: 0 }}>
                    <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop: 24 }}>
                        登录
                    </Button>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '12px' }}>
                        <span style={{ cursor: 'pointer', color: "#1890ff" }} onClick={() => this.fastRge()}>快速注册</span>
                    </div>
                </Form.Item>
            </Form>
        );
    }
}

export default Form.create()(FLogin);


// WEBPACK FOOTER //
// ./src/routes/find/FLogin.jsx